import utils from '../../../utils/utils.js';

export default {
  async fetchWorkspaceFeeders(context, payload) {
    const pageNumber = payload.pageNumber;
    const pageSize = payload.pageSize;
    const sortColumn = payload.sortColumn;
    const sortDirection = payload.sortDirection;
    const searchText = payload.searchText;

    const responseData = await utils.utility.fetch(
      `api/Setting/GetWorkspaceFeeders?pageNumber=${pageNumber}&pageSize=${pageSize}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&searchText=${searchText}`,
      "GET",
      null,
      null
    );
    context.commit("setWorkspaceFeeders", responseData.data);
  },

  async putWorkspaceFeederType(context, payload) {
    await utils.utility.fetch(
      `api/Setting/UpdateWorkspaceFeederType`,
      "PUT",
      null,
      payload
    );
  },
};
